export default "__VITE_ASSET__b574c41f__"